module.exports = "pegasus_template/assets/tech/holiday/101.png";